// extracted by mini-css-extract-plugin
export default {"pattern":"SidePattern_pattern__tJAul","primary":"SidePattern_primary__caq75","secondary":"SidePattern_secondary__UVDUs"};